import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { lineClamp } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import { ReactComponent as SvgArrow } from '@img/icons/chevron-down.svg';
import { ReactComponent as SvgExternal } from '@img/icons/chevron-down.svg';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
import { cssVar, setCssVar } from '@helpers/cssVar';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
const Container = styled(m.nav) `
  ${setCssVar('accentColor', brand.sage.sageDark)};
  ${setCssVar('bgColor', brand.sage.sageDark)};
  ${setCssVar('fgColor', brand.white)};
  ${setCssVar('fgColorAlt', brand.white)};

  display: flex;
  background: ${cssVar('bgColor')};
  flex-direction: column;
  margin: 0;
  padding: 20px 15px 0;
  height: 100%;
  max-height: -webkit-fill-available;

  @media ${from(Device.TabletLarge)} {
    height: auto;
  }

  @media ${from(Device.Desktop)} {
    display: none;
  }
`;
const BackButton = styled.button `
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  color: ${cssVar('fgColor')};
  font-size: 16px;
  height: 20px;
  line-height: 22px;
  margin: 0 0 10px;
  padding: 0;
  text-align: left;

  &:focus,
  &:hover {
    background: none;
    border: 0;
  }
`;
const BackArrow = styled(SvgArrow) `
  display: inline-block;
  margin: 0 8px 0 0;
  transform: translateY(-1px) rotate(90deg);
  height: 17px;
  width: 10px;
`;
const Title = styled.a `
  ${fonts.gazpacho.medium};
  display: flex;
  align-items: center;
  color: ${cssVar('fgColor')};
  height: 40px;
  font-size: 24px;
  line-height: 28px;
  padding: 0;
  text-align: left;
  text-decoration: none;

  &:hover {
    background: ${cssVar('accentColor')};
    border: 0;
    color: ${cssVar('fgColorAlt')};
  }
`;
const LinkHolder = styled.div `
  display: flex;
  flex-wrap: wrap;
  flex: 1 0 auto;
  align-content: flex-start;
  padding-bottom: 20px;
  border-bottom: 1px solid ${brand.white};
`;
const LinkDescription = styled.p `
  ${lineClamp(2, 'block')};
  ${fonts.matter.medium};
  font-size: 16px;
  line-height: 22px;
  margin-top: 8px;
  color: ${cssVar('fgColor')};
  width: 100%;

  @media ${until(Device.TabletLarge)} {
    display: none;
  }
`;
const linkStyles = css `
  ${fonts.matter.medium};
  display: block;
  align-items: center;
  border: 0;
  background: ${cssVar('bgColor')};
  color: ${cssVar('fgColor')};
  font-size: 18px;
  line-height: 25px;
  margin: 0;
  min-width: 0;
  padding: 8px 36px 8px 0;
  text-align: left;
  text-overflow: ellipsis;
  width: 100%;

  &:focus,
  &:hover {
    background: ${cssVar('accentColor')};
    border: 0;
    color: ${cssVar('fgColorAlt')};

    ${LinkDescription} {
      color: ${cssVar('fgColorAlt')};
    }
  }
`;
const ItemButton = styled.button `
  ${linkStyles}
  position: relative;
`;
const ItemLink = styled.a `
  ${linkStyles}
  padding: 8px 10px 8px 0;
  text-decoration: none;
`;
const ItemArrow = styled(SvgArrow) `
  position: absolute;
  top: 50%;
  right: 18px;
  transform: translateY(-50%) rotate(-90deg);
  margin-left: auto;
  height: 6px;
  width: 14px;
`;
const Item = styled.div `
  display: block;
  padding: 0;
  margin: 0 0 3px;
  overflow: hidden;
  position: relative;

  @media ${until(Device.TabletLarge)} {
    flex: 1 0 100%;
  }

  ${({ dropDownType }) => dropDownType === 2 &&
    css `
      ${BgImageHolder} {
        display: none;
      }
    `}

  ${({ hasImage }) => hasImage &&
    css `
      /* @media ${until(Device.TabletLarge)} {
        &:nth-child(odd) {
          ${ItemLink} {
            padding: 8px 10px 8px 0;
          }
        }

        &:nth-child(even) {
          ${ItemLink} {
            padding: 8px 0 8px 10px;
          }
        }
      } */

      @media ${from(Device.TabletLarge)} {
        flex: 0 0 25%;

        ${ContentHolder} {
          ${fonts.gazpacho.medium};
        }

        &:nth-child(4n) {
          ${ItemLink} {
            padding: 8px 0 8px 10px;
          }
        }

        &:nth-child(4n + 1) {
          ${ItemLink} {
            padding: 8px 10px 8px 0;
          }
        }
      }
    `}

  ${({ isChild }) => isChild &&
    css `
      ${ItemButton},
      ${ItemLink} {
        ${fonts.gazpacho.medium};
        font-size: 24px;
        line-height: 28px;
      }

      ${ItemArrow} {
        height: 11px;
        width: 26px;
      }
    `}
`;
const External = styled(SvgExternal) `
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  display: block;
  height: 17px;
  width: 17px;
`;
const Border = styled.hr `
  width: calc(100% - 36px);
  border: 1px solid ${brand.grey.greyLight};
`;
const BgImageHolder = styled.div `
  width: 100%;
  height: 120px;
  margin-bottom: 15px;
  position: relative;
  overflow: hidden;

  @media ${until(Device.TabletLarge)} {
    display: none;
  }
`;
const BgImage = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  width: 100%;
`;
const ContentHolder = styled.div ``;
const NavBase = styled.div `
  justify-content: center;
  align-items: flex-end;
  display: flex;

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const NavCtaHolder = styled.div `
  padding: 35px 18px 125px;
  display: grid;
  gap: 16px;
  grid-template-rows: auto auto;
  justify-content: center;

  @media ${from(Device.Tablet)} {
    padding-bottom: 25px;
  }

  a,
  button {
    margin-right: 0;
  }
`;
const TopLinkHolder = styled.div `
  padding: 25px 18px 10px;
  width: 100%;
`;
const TopLinkList = styled.div `
  display: block;
`;
const TopLinkItem = styled.a `
  display: block;
  ${fonts.matter.medium};
  font-size: 16px;
  line-height: 22px;
  text-decoration: none;
  margin-bottom: 10px;
  color: ${cssVar('accentColor')};
`;
const CtaBtn = styled(LinkButton) `
  margin-right: 20px;
  min-width: 100px;
`;
export default {
    BackArrow,
    BackButton,
    BgImage,
    BgImageHolder,
    Border,
    ContentHolder,
    Container,
    CtaBtn,
    External,
    Item,
    ItemArrow,
    ItemButton,
    ItemLink,
    LinkDescription,
    LinkHolder,
    NavBase,
    NavCtaHolder,
    Title,
    TopLinkHolder,
    TopLinkItem,
    TopLinkList,
};
